
// const host = "http://localhost:3016/api/v1/";
const host = "https://serviceapi.suryatelematics.com/api/v1/";


export default {
  LOGIN: `${host}auth/login`,
  AUTH: `${host}auth`,
  USERS: `${host}users`,
  CUSTOMERS: `${host}customers`,
  PRODUCT: `${host}products`,
  DROPDOWN: `${host}dropdowns`,
  ADDRESS: `${host}address`,
  JOBCARD: `${host}jobcards`,
  JOBCARD_SERVICES: `${host}jobcard_services`,
  APP_VERSION: `${host}appversion`,
  LOGS: `${host}jobcardlogs`,
  COMMENTS: `${host}jobcardcomments`,
  REPORT: `${host}jobcards/reports`,
  EMPLOYEE_REPORT: `${host}jobcards/employee-report`,
  EMPLOYEE_REPORT_ENTRIES: `${host}jobcards/employee-report/entries`,
  INFORMATION_EMPLOYEE_REPORT: `${host}informations/employee-report`,
  AREA_SEARCH: `${host}customers/getarealist?search=`,
  NOTIFICATION: `${host}jobcards/reminder`,
  CUSTOMER_PRODUCT: `${host}cm_products`,
  PRODUCT_DROPDOWN: `${host}dropdowns/PRdevicetype`,
  AMC_STATUS: `${host}jobcards/re_amc`,
  AMC_STATUS_UPDATE: `${host}jobcards/udpate_amcstatus`,
  INFORMATION: `${host}informations`,
  FOLLOW_UP: `${host}followups`,
  ATTENDANCE: `${host}attendance`,
  DOCUMENTATION: `${host}documentation`,
  UPLOAD_IMAGE: `${host}documentation/upload`,
  DOCUMENTATION_IMAGE_HOST: `${host.replace("/api/v1/", "")}/images`,
  PRODUCT_IMAGE_HOST: `${host.replace("/api/v1/", "")}/Productimages`,
  AUDIO_IMAGE_HOST: `${host.replace("/api/v1/", "")}/audio`,
  OFFLINE: `${host}offline`,
  SOLAR: `${host}solar`,
  ADDRESS_FILTER: `${host}customers/address/filter`,
  CONFIG: `${host}config`,
  LOCATION: `${host}location`,
  LOCATION_LIVE: `${host}location/live`,
  LOCATION_LOGS: `${host}location/logs`,
  STALL_REGISTRATION: `${host}stall-registration`,
  STALL_CUSTOMER_LOOKUP: `${host}stall-registration/customer-lookup`,
  STALL_PRODUCT_TYPE: `${host}stall-product-type`,
};
